import * as actionTypes from './actionTypes';
import { getContentModelId } from '../selectors/baseContentModelSelectors';
import { getSelectedItemId } from '../selectors/selectionSelectors';
// @ts-expect-error not yet migrated
import { clearSelectedItem } from './selectionActions';
import { getCurrentGridLayoutSectionToAddTo } from '../selectors/sectionsSelectors';
import { fetchGridLayoutBufferByDndAreaName, isGridLayoutWithMeta } from '../../api/GridLayoutsBufferApi';
import { fetchLayoutGenerationTask, getSectionFromAgentMessages, startLayoutGenerationTask, Tasks } from '../../api/GridsLayoutGenerationApi';
export const setNodeStyles = (nodeId, gridLayoutId, isEditorProvidedModuleStyles, activeBreakpoint, styles) => ({
  type: actionTypes.GRID_LAYOUTS_SET_NODE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    isEditorProvidedModuleStyles,
    activeBreakpoint,
    styles
  }
});
export const setOldModuleStyles = (nodeId, gridLayoutId, styles) => ({
  type: actionTypes.GRID_SET_OLD_MODULE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    styles
  }
});
export const setContainerLayoutType = (nodeId, gridLayoutId, activeBreakpoint, layoutType) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_NODE_LAYOUT,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    layoutType
  }
});
export const updateGridTableDefinition = (nodeId, gridLayoutId, activeBreakpoint, newRows, newColumns) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_TABLE_DEFINITION,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    newRows,
    newColumns
  }
});
export const cloneNodeAndInsertAfterOriginalInGridLayout = (gridLayoutId, nodeId) => dispatch => {
  dispatch({
    type: actionTypes.GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteContainerFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_CONTAINER_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteSectionFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_SECTION_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const insertBlankSectionInGridLayout = newSectionLayout => (dispatch, getState) => {
  const state = getState();
  const currentGridLayoutSectionToAddTo = getCurrentGridLayoutSectionToAddTo(state);
  if (currentGridLayoutSectionToAddTo) {
    dispatch({
      type: actionTypes.GRID_LAYOUTS_INSERT_BLANK_SECTION,
      payload: {
        gridLayoutId: currentGridLayoutSectionToAddTo.gridLayoutId,
        beforeNodeId: currentGridLayoutSectionToAddTo.beforeNodeId,
        afterNodeId: currentGridLayoutSectionToAddTo.afterNodeId,
        newSectionLayout
      }
    });
  } else {
    console.error('No current grid layout section to add to');
  }
};
export const deleteModuleFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItem = getSelectedItemId(state);
  if (selectedItem === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_MODULE_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
const pollForLayoutGenerationTask = (gridLayoutId, nodeId, taskId) => async dispatch => {
  const pollTask = async () => {
    try {
      const {
        taskStatus,
        agentMessages
      } = await fetchLayoutGenerationTask(taskId);
      switch (taskStatus) {
        case 'COMPLETE':
          {
            const maybeSectionData = getSectionFromAgentMessages(agentMessages, nodeId);
            dispatch({
              type: actionTypes.GRID_LAYOUTS_GENERATION_SUCCEEDED,
              payload: {
                gridLayoutId,
                status: 'COMPLETE',
                agentMessages
              }
            });
            if (maybeSectionData !== null && maybeSectionData !== void 0 && maybeSectionData.normalizedSection) {
              const {
                normalizedSection: generatedSection,
                nextSiblingSectionNodeId: beforeNodeId
              } = maybeSectionData;
              dispatch({
                type: actionTypes.GRID_LAYOUTS_REPLACE_SECTION_WITH_GENERATED_LAYOUT,
                payload: {
                  gridLayoutId,
                  sectionNodeId: nodeId,
                  generatedSection,
                  beforeNodeId
                }
              });
            } else {
              console.error('No grid layout response from agent messages');
              dispatch({
                type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
                payload: {
                  gridLayoutId,
                  status: 'FAILED'
                }
              });
            }
            return; // Stop polling
          }
        case 'FAILED':
          dispatch({
            type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
            payload: {
              gridLayoutId,
              status: 'FAILED'
            }
          });
          return;
        // Stop polling
        default:
          // Continue polling after 1 second delay
          setTimeout(() => {
            void pollTask();
          }, 1000);
          break;
      }
    } catch (e) {
      console.error(e);
      dispatch({
        type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
        payload: {
          gridLayoutId,
          status: 'FAILED'
        }
      });
      // Stop polling on error
      return;
    }
  };
  await pollTask();
};
export const generateGridLayout = (gridLayoutId, nodeId) => async (dispatch, getState) => {
  const state = getState();
  const contentId = getContentModelId(state);
  let newTaskId;
  try {
    // Note: this is a known workaround around E1.0 vs E2.0 and a product of RPC and non-RPC services (`combined-edit-data` vs `grid-buffers`)
    // This data is in redux, but stored in a shape that the layout gen RPC does not expect.
    // for the lifespan of E1.0, it's probably easiest to fetch it directly. More context in: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/20538#discussion_r4971878
    const {
      metaObject
    } = await fetchGridLayoutBufferByDndAreaName(contentId, gridLayoutId);
    if (isGridLayoutWithMeta(metaObject)) {
      const {
        gridLayout: fetchedGridLayout
      } = metaObject;
      const {
        taskId
      } = await startLayoutGenerationTask({
        task: Tasks.TRY_ANOTHER_LAYOUT,
        contentId,
        focusedNodeId: nodeId,
        gridLayout: fetchedGridLayout
      });
      if (taskId) {
        newTaskId = taskId;
      }
    }
    if (newTaskId) {
      dispatch({
        type: actionTypes.GRID_LAYOUTS_GENERATION_STARTED,
        payload: {
          gridLayoutId,
          contentId,
          nodeId,
          taskId: newTaskId
        }
      });
      await dispatch(pollForLayoutGenerationTask(gridLayoutId, nodeId, newTaskId));
    }
  } catch (e) {
    console.error(e);
    dispatch({
      type: actionTypes.GRID_LAYOUTS_GENERATION_FAILED,
      payload: {
        gridLayoutId,
        contentId
      }
    });
  }
};